<template>
  <div class="main">
    <a-spin tip="正在登录中..." />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import storage from 'store'
export default {
  created () {
    storage.clearAll()
    this.Login({ code: this.$route.query.code })
      .then(() => {
        const hasRedirectUrl = this.$route.query.redirect_url
        this.$router.push(hasRedirectUrl || '/')
      })
  },
  methods: {
    ...mapActions(['Login', 'Logout'])
  }
}
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 500px
}
</style>
